import React from 'react';

const Price = () => (
  <>
    <section className={"effect-section theme-bg parallax"}>

<div className={"container"}>
  <div className={"row full-screen align-items-center p-100px-tb justify-content-center"}>       
    <div className={"col-lg-6 col-md-7 m-30px-tb"}>
    <h1 className={"display-4 m-20px-b white-color"}>Cotiza tu proyecto</h1>
      <img src={require('../images/desarrollo_-01.png')} title="phone" alt="phone"/>
    </div>
    <div className={"col-lg-6 col-md-7 m-30px-tb"}>
    <form>
        <div className={"flex-column flex-md-row m-5px-b white-color"}>
          <label htmlFor={"newsletter"}>Mantente informado</label>
          <input
            id={"newsletter"}
            type={"text"}
            className={"form-control m-5px-r md-m-0px-r md-m-10px-b"}
            placeholder={"Nombre y apellidos"}
          />
          <br></br>
           <input
            id={"newsletter"}
            type={"email"}
            className={"form-control m-5px-r md-m-0px-r md-m-10px-b"}
            placeholder={"Ingresa tu e-mail"}
          />
          <br></br>
           <input
            id={"newsletter"}
            type={"text"}
            className={"form-control m-5px-r md-m-0px-r md-m-10px-b"}
            placeholder={"Plan elegido"}
          />
          <br></br>
          <input
            id={"newsletter"}
            type={"text"}
            className={"form-control m-5px-r md-m-0px-r md-m-10px-b"}
            placeholder={"Tipo de proyecto"}
          />
          <br>
          </br>
          <p>Quiero mi cotizacion a través de </p>
                                                <select class="form-control m-5px-r md-m-0px-r md-m-10px-b">
                                                    <option value="A">Videollamada</option>
                                                    <option value="B">Correo electronico</option>
                                                </select>

          <br></br>
          <button
            className={"m-btn m-btn-radius m-btn-green flex-shrink-0"}
            type={"submit"}
          >
            Cotizar
          </button>
        </div>
      </form>
    </div>
  </div>

</div>
</section>
  </>
);

export default Price;
